import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { TRIGGER_TECH_OPS_BASE_PATH } from '../../../../../../features/meta/trigger/trigger-routing';

export const Route = createFileRoute('/_app/_o5/_o5-required/tech-ops/trigger/_trigger')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'o5-trigger-list',
        label: 'Triggers',
        to: TRIGGER_TECH_OPS_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
